import Vue from "vue";
import words from "voca/words";
import upperCase from "voca/upper_case";

export const userInitialsFilter = user => {
	if ( user.name ) {
		const parts = words( user.name );
		const firstName = parts[ 0 ] || " ";
		// NOTE: some usernames are the email address, so we ignore last name here
		// so that we don't mistakenly apply the domain as the last name
		const lastName = ( !parts.includes( "@" ) && parts[ 1 ] ) || " ";
		return upperCase( `${firstName[ 0 ]}${lastName[ 0 ]}`.trim() );
	}
	if ( user.email ) {
		const parts = user.email.split( "@" );
		const [ first, last, ] = parts[ 0 ].split( "." );
		const firstInitial = first || " ";
		const lastInitial = last || " ";
		return upperCase( `${firstInitial[ 0 ]}${lastInitial[ 0 ]}`.trim() );
	}
	return "?";
};

export const userNameOrEmailFilter = user => {
	return user.name || user.preferredName || user.email || "";
};

Vue.filter( "initials", userInitialsFilter );
Vue.filter( "nameOrEmail", userNameOrEmailFilter );



// WEBPACK FOOTER //
// ./src/filters/user.js